import React, { forwardRef, type ComponentProps } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import { Content } from '@radix-ui/react-popover';

export type PopoverContentProps = ComponentProps<typeof Content>;

export const PopoverContent = forwardRef<HTMLDivElement, PopoverContentProps>(
  ({ className, ...props }, forwardedRef) => {
    const defaultClasses = [
      'flex',
      'flex-col',
      'items-stretch',
      'max-w-[calc(100vw-(--spacing(4)))]',
      'max-h-[calc(100vw-(--spacing(4)))]',
      'sm:max-w-[calc(100vw-2*(--spacing(16)))]',
      'sm:max-h-[calc(100vw-2*(--spacing(16)))]',
      'min-w-[200px]',
      'bg-surface-overlay',
      'rounded-lg',
      '[filter:drop-shadow(0px_0px_1px_var(--color-border))_drop-shadow(0_3px_15px_var(--palette-black-alpha-400))]',
      'z-modal',
      'focus:outline-none',
      'data-[side=bottom]:motion-safe:animate-fade-in-bottom',
      'data-[state=closed]:data-[side=bottom]:motion-safe:animate-fade-out-bottom',
      'data-[side=top]:motion-safe:animate-fade-in-top',
      'data-[state=closed]:data-[side=top]:motion-safe:animate-fade-out-top',
      'data-[side=left]:motion-safe:animate-fade-in-left',
      'data-[state=closed]:data-[side=left]:motion-safe:animate-fade-out-left',
      'data-[side=right]:motion-safe:animate-fade-in-right',
      'data-[state=closed]:data-[side=right]:motion-safe:animate-fade-out-right',
    ];
    return (
      <Content
        ref={forwardedRef}
        collisionPadding={16}
        arrowPadding={4}
        sideOffset={1}
        className={cn(defaultClasses, className)}
        aria-labelledby="ragnar-popover-title"
        {...props}
      />
    );
  },
);
